<template>
  <div class="custom-title bX">
    <span class="mc f18 cY">
      <img src="@/assets/img/icon-arr-r.png" class="icon icon01" alt="">
      <span class="val">{{mc}}</span>
      <img src="@/assets/img/icon-suquare.png" class="icon icon02" alt="">
    </span>
    <a v-if="path" :href="path" class="morea cY">更多<i class="el-icon-arrow-right"></i></a>
  </div>
</template>

<script>
  export default {
    name: "customTitle",
    props: {
      mc: {
        type: String,
        default: ''
      },
      path: {
        type: String,
        default: ''
      }
    },
  }
</script>

<style lang="scss" scoped>
  .custom-title {
    padding: 0.12rem 0;
    border-bottom: 1px solid #2F915D;

    .mc {
      .icon01 {
        height: .12rem;
      }

      .icon02 {
        height: .05rem;
        align-items: flex-start;
        position: relative;
        top: -0.05rem;
      }

      .val {
        font-size: .2rem;
        margin: 0 .08rem;
        font-weight: bold;
        color: #2F915D;
      }
    }

    .morea {
      color: #2F915D;

      &:hover {
        color: #0e713c;
      }
    }
  }

  
  @media only screen and (max-width: 767px) {
    
    .custom-title{
      padding: 0.2rem 0;
      .mc{
        .val{font-size:0.28rem !important}
      }
    }
    
  }
</style>